export default "__VITE_ASSET__BDwZGyt1__"